// src/utils/fetchWaitingStudents.js
import http from "../api/apiClient";

/**
 * Normalizes various paginated/list response shapes to a flat array.
 */
const normalizeList = (data) =>
  Array.isArray(data)
    ? data
    : Array.isArray(data?.content)
    ? data.content
    : Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data?.data)
    ? data.data
    : [];

/**
 * Fetches the count of waiting students from the API.
 * Uses the shared axios instance (with Keycloak interceptor).
 *
 * 1) Tries server-side filter (?waiting=true)
 * 2) Falls back to fetching all children and filtering on the client
 *
 * @returns {Promise<number>} Number of waiting students
 */
export async function fetchWaitingStudents() {
  try {
    // Try server-side filtering first
    const res = await http.get("/children", { params: { waiting: true } });
    const list = normalizeList(res.data);
    if (list.length > 0) return list.length;

    // Fallback: fetch all and filter on the client
    const res2 = await http.get("/children");
    const all = normalizeList(res2.data);
    return all.filter((c) => !!c.waiting).length;
  } catch (error) {
    // If access is forbidden, treat as zero instead of failing the whole page
    if (error?.response?.status === 403) return 0;
    // Re-throw for the caller to handle (so ErrorPage kan tonen)
    throw error;
  }
}